<template>
  <div class="model-wrapper" :style="styleObj">
    <div
      class="btn model"
      @click="clickHandler"
      @touchstart="touchStartPreventDraft($event)"
      @touchmove="touchMovePreventDraft($event)"
    ></div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'model',
  props: {
    zIndex: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      touch: {
        startX: 0,
        startY: 0,
        endX: 0,
        endY: 0,
      },
      styleObj: null,
    };
  },
  methods: {
    clickHandler() {
      this.$emit('clickHandler');
    },
    touchStartPreventDraft(ev) {
      this.touch.startX = ev.touches[0].pageX;
      this.touch.startY = ev.touches[0].pageY;
      // console.log(ev);
    },
    touchMovePreventDraft(ev) {
      // console.log(ev);
      this.touch.endX = ev.changedTouches[0].pageX;
      this.touch.endY = ev.changedTouches[0].pageY;
      const direction = this.getSlideDirection(
        this.touch.startX,
        this.touch.startY,
        this.touch.endX,
        this.touch.endY,
      );
      switch (direction) {
      case 0:
        ev.stopPropagation();
        ev.preventDefault();
        break;
      case 1:
        // 向上
        ev.stopPropagation();
        ev.preventDefault();
        break;
      case 2:
        // 向下
        ev.stopPropagation();
        ev.preventDefault();
        break;

      default:
      }
    },
    getSlideDirection(startX, startY, endX, endY) {
      const dy = startY - endY;
      // let dx = endX - startX;
      let result = 0;
      if (dy > 0) {
        // 向上滑动
        result = 1;
      } else if (dy < 0) {
        // 向下滑动
        result = 2;
      } else {
        result = 0;
      }
      return result;
    },
  },
  created() {
    if (this.zIndex !== 10) {
      this.styleObj = {
        zIndex: this.zIndex,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
.model-wrapper {
  position: fixed;
  max-width: 414px;
  width: 100%;
  height: 100%;
  left: 50%;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  top: 0;
  z-index: 10;
}

.model {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1;
}
</style>
